import { makeStyles } from '@material-ui/core';
import { bottomSheetShadow } from '../../theme';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0.938rem',
    width: '100%',
  },
  mobileNavigation: {
    position: 'sticky',
    bottom: 0,
    background: theme.palette.white.main,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    boxShadow: `0px -2px 5px 0px ${bottomSheetShadow}`,
    marginTop: 50,
    zIndex: 1301,
  },
  backButton: {
    marginRight: '1rem',
  },
}));

export default useStyles;
